import { ApiCSVRule, ApiProject } from "@incendium/api";
import { CSVService } from "Apis";
import { useProjectSharedState } from "./useSharedState";

const fetchCSVRules = async (selectedProject: ApiProject | null) => {
  if (selectedProject) {
    const res = await CSVService.cSVServiceListRules();
    return res.rules || [];
  }
  return [];
};

export const useCSVRules = () => {
  const { state, setState } = useProjectSharedState("CSVRules", [], fetchCSVRules);

  return {
    CSVRules: state as ApiCSVRule[],
    setCSVRules: setState,
  };
};
